import $ from 'jquery';
import initInfluencerShareLink from 'modules/influencer-share-link';

$(() => {
    initInfluencerShareLink();
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/influencer-share-link/index.js